import api from "./api";

const StoreService = {
  getAll: async (page = 1, limit = 20) => {
  const res = await api.get(`/store/getAll?page=${page}&limit=${limit}`);
  return res.data;
},


  getById: async (id) => {
    const res = await api.get(`/store/getById/${id}`);
    return res.data;
  },

  getActive: async () => {
    const res = await api.get("/store/getActive");
    return res.data;
  },

  saveStore: async (data) => {
    const res = await api.post("/store/save", data);
    return res.data;
  },

  updateStore: async (id, data) => {
    const res = await api.put(`/store/update/${id}`, data);
    return res.data;
  },

  deleteStore: async (id) => {
    const res = await api.delete(`/store/${id}`);
    return res.data;
  },

  updateStatus: async (id, status) => {
    const res = await api.put(`/store/updateStatus/${id}`, { status });
    return res.data;
  },
};

export default StoreService;
